module.exports = __webpack_public_path__ + "static/media/draw.7f8eb51e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/draw.svg
// module id = 547
// module chunks = 0